import StartupWizard from '../components/StartupWizard';

export default function NewStartupPage() {
  return (
    <div>
      <h1 className="text-3xl font-bold text-white mb-2">Create New Startup</h1>
      <p className="text-gray-400 mb-8">Fill in the details to set up your startup in StartupScore.</p>
      <StartupWizard />
    </div>
  );
}
